import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { UseFormReset } from 'react-hook-form';

import { getUser } from '../api';
import { usersQueryKeys } from '../data';
import { useEditUser } from '../store';
import { EditUserForm } from './use-edit-user-form';

type UseGetUser = {
  resetForm: UseFormReset<EditUserForm>;
};

export const useGetUser = ({ resetForm }: UseGetUser) => {
  const userId = useEditUser();

  const getUserQuery = useQuery({
    queryKey: [...usersQueryKeys.getUser, userId],

    queryFn: getUser.bind(null, userId),
  });

  useEffect(() => {
    if (
      getUserQuery.isError ||
      getUserQuery.isFetched === false ||
      getUserQuery.data === undefined
    )
      return;
    resetForm(getUserQuery.data);
  }, [
    getUserQuery.data,
    getUserQuery.isError,
    getUserQuery.isFetched,
    resetForm,
  ]);

  return getUserQuery;
};
